import { HttpClient } from "@angular/common/http";
import { Component, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { InviaNotificaAggiornamentoRequest } from "src/app/common/models/dto/invia-notifica-aggiornamento-request";
import { FascicoloMap } from "src/app/common/models/fascicolo-map";
import { Fascicolo } from "src/app/common/models/fascicolo/fascicolo";
import { FascicoloFull } from "src/app/common/models/fascicolo/fascicolo-full";
import { Pratica } from "src/app/common/models/pratica/pratica";
import { Utente } from "src/app/common/models/utente";
import { ServicePathsSettings } from "src/app/core/configuration/service-paths-settings";
import { HelpersService } from "src/app/core/services/helpers.service";
import { OperationsService } from "src/app/core/services/operations.service";
import { RoutingConfigurationUtilService } from "src/app/core/services/routing-configuration-util.service";
import { ViewManagerService } from "src/app/core/services/view-manager-service";

declare var removeEmptyObject: any;
declare var closeModal: any;
declare var openModal: any;
declare var getFascicoloMapSync: any;

@Component({
  selector: "div [invia-notifica-modal]",
  templateUrl: "invia-notifica-modal.component.html",
})
export class InviaNotificaModalComponent implements OnDestroy {
  private fascicolo: Fascicolo;
  private pratica: Pratica;

  nomeAssegnatario: Utente = null;
  request: InviaNotificaAggiornamentoRequest = new InviaNotificaAggiornamentoRequest();
  inviaNotificaForm : FormGroup;
  assegnatariOptions: Utente [] = [];
  remainingChars: number = 255;
  private subs: Subscription = new Subscription();

  constructor(
    private viewManager: ViewManagerService,
    private operationService: OperationsService,
    private http: HttpClient,
    private helpers: HelpersService,
    private router: Router,
    private campiForm: FormBuilder,
    private routingService: RoutingConfigurationUtilService
  ) {
  }

  ngOnInit(){
    this.initRequest();
    this.createForm();
  }

  inizializza(
    fascicolo: Fascicolo,
    pratica: Pratica,
    recallFascicolo: boolean
  ) {
    if (recallFascicolo) {
      let fascicoloMap: FascicoloMap = <FascicoloMap>(
        getFascicoloMapSync(pratica.tipoPratica.id, fascicolo.tipoFascicolo.id)
      );
      this.operationService
        .readFascicolo(fascicoloMap.pathView, fascicolo.id)
        .subscribe((response) => response);
      this.pratica = pratica;
    } else {
      this.pratica = pratica;
      this.fascicolo = fascicolo;
    }
    if (this.assegnatariOptions.length === 0) {
      this.helpers.getUtentiNotifica(fascicolo.id).subscribe(response => {
        this.assegnatariOptions = response
        .map(user => {
        const nome = user.nome ? user.nome : '';
          const cognome = user.cognome ? user.cognome : '';
            return {
              ...user,
              cognomeNome: `${cognome} ${nome}`, // Concatenazione dei valori di nome e cognome
              username: user.username,
            };
        })
        .sort((a, b) => a.cognomeNome.localeCompare(b.cognomeNome)); // Ordinamento per cognomeNome
      })
    }
    openModal("modalInviaNotifica");
  }

  initRequest(){
    this.request.username = "";
    this.request.testoNotifica = "";
    console.log(this.request)

  }

 createForm(){
    this.inviaNotificaForm = this.campiForm.group({
      testoNotifica: [this.request.testoNotifica, Validators.required],
      nomeAssegnatario:[null, Validators.required]
    })
    const tesxtCtrl = this.inviaNotificaForm.get('testoNotifica');
    if (tesxtCtrl) {
      this.remainingChars = 255 - (tesxtCtrl.value ? tesxtCtrl.value.length : 0);
      //Observable che emette un evento ogni volta che il valore del controllo cambia, cioè quando l’utente digita o cancella qualcosa.
      this.subs = (tesxtCtrl.valueChanges).subscribe((v: string) => {
        this.remainingChars = 255 - (v ? v.length : 0);
      });
    }
  }

  resetRequest(){
    this.request.testoNotifica = "";
    this.nomeAssegnatario = null;
    this.inviaNotificaForm.get('nomeAssegnatario')?.setValue(null);
  }

  onAssegnatarioSelected(user: any) {
    console.log(user)
    this.nomeAssegnatario = user || null;
    this.request.username = user ? user.username : null;
    this.inviaNotificaForm.get('nomeAssegnatario')?.setValue(user);
  }



  invia(){
    this.http.post(
      ServicePathsSettings.DOMINIO +
      ServicePathsSettings.OPERATIONS_PATH +
      '/gp/notifica/' +
      this.fascicolo.id +
      '/send', this.request
    ).subscribe(response =>
      {
        console.log(response);
        closeModal("modalInviaNotifica")
        //this.viewManager._refreshNotifiche.next({});
        this.resetRequest();
      })
  }

  ngOnDestroy() {
    if(this.subs){
      this.subs.unsubscribe();
    }    
  }

}
